import { render, staticRenderFns } from "./wx-bar.vue?vue&type=template&id=3cc90a9e&scoped=true&"
import script from "./wx-bar.vue?vue&type=script&lang=ts&"
export * from "./wx-bar.vue?vue&type=script&lang=ts&"
import style0 from "./wx-bar.vue?vue&type=style&index=0&id=3cc90a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc90a9e",
  null
  
)

export default component.exports